import '../App.scss';
import ChooseSignatureAuthenticationPage from '../pages/ChooseSignatureAuthenticationPage';
import ErrorPage from '../pages/ErrorPage';
import CaiPresentationPageLinear from '../pages/linear/CaiPresentationPageLinear';
import EndThankYouPageLinear from '../pages/linear/EndThankYouPageLinear';
import EndToDriverThankYouPageLinear from '../pages/linear/EndToDriverThankYouPageLinear';
import EndTokenExpiredLinearPage from '../pages/linear/EndTokenExpiredLinearPage';
import OptionalDocumentsPageLinear from '../pages/linear/OptionalDocumentsPageLinear';
import QuestionAgreementPageLinear from '../pages/linear/QuestionAgreementPageLinear';
import RealtimeAccettazioneCaiPageLinear from '../pages/linear/RealtimeAccettazioneCaiPageLinear';
import RequireDenunciaPageLinear from '../pages/linear/RequireDenunciaPageLinear';
import RequireDocumentsPageLinear from '../pages/linear/RequireDocumentsPageLinear';
import ResendCommunicationPageLinear from '../pages/linear/ResendCommunicationPage';
import SignatureProposalPageLinear from '../pages/linear/SignatureProposalPageLinear';
import WelcomePageLinear from '../pages/linear/WelcomePageLinear';
import { RouteType } from "../types/commonTypes";
import { LINEAR_PATHS } from './linearRouteConstants';

export const LINEAR_ROUTES: RouteType[] = [{
    path: LINEAR_PATHS.CAI_PRESENTATION_PAGE,
    element: <CaiPresentationPageLinear />
}, {
    path: LINEAR_PATHS.QUESTION_AGREEMENT_PAGE,
    element: <QuestionAgreementPageLinear />
}, {
    path: LINEAR_PATHS.SIGNATURE_PROPOSAL_PAGE,
    element: <SignatureProposalPageLinear />
}, {
    path: LINEAR_PATHS.REQUIRE_DOCUMENTS_PAGE,
    element: <RequireDocumentsPageLinear />
}, {
    path: LINEAR_PATHS.REQUIRE_DENUNCIA_PAGE,
    element: <RequireDenunciaPageLinear />
}, {
    path: LINEAR_PATHS.OPTIONAL_DOCUMENTS_PAGE,
    element: <OptionalDocumentsPageLinear />
}, {
    path: LINEAR_PATHS.WELCOME_FIRST_PAGE,
    element: <WelcomePageLinear />
}, {
    path: LINEAR_PATHS.RESEND_COMMUNICATION_PAGE,
    element: <ResendCommunicationPageLinear />
}, {
    path: LINEAR_PATHS.END_THANK_YOU_PAGE,
    element: <EndThankYouPageLinear />
}, {
    path: LINEAR_PATHS.END_TO_DRIVER_THANK_YOU_PAGE,
    element: <EndToDriverThankYouPageLinear />
}, {
    path: LINEAR_PATHS.TOKEN_EXPIRED,
    element: <EndTokenExpiredLinearPage />
},{
    path: LINEAR_PATHS.LINEAR_REALTIME_ACCETTAZIONE_CAI_PAGE,
    element: <RealtimeAccettazioneCaiPageLinear />
}, {
    path: LINEAR_PATHS.CHOOSE_SIGNATURE_AUTHENTICATION,
    element: <ChooseSignatureAuthenticationPage />
}, {
    path: "*",
    element: <ErrorPage />,
}]
